"use client";

import { getDiscoverSessionProps } from "@/lib/analytics/discover-attribution";
import { EMBEDDED_IN_APP_COOKIE } from "@/lib/embeddedInAppCookie";
import { useTrackOnceConsented } from "@/hooks/useTrackOnceConsented";
import { parseSelection } from "@/components/discover/filters/selection";
import { type MapAreaId, mapAreaIds } from "@/utils/location";
import { slugify } from "@/utils/slugs";
import Cookies from "js-cookie";
import { useParams, useSearchParams } from "next/navigation";

export function SessionStartTracker() {
  const searchParams = useSearchParams();
  const { location, activity } = useParams<{
    location?: string;
    activity?: string;
  }>();

  useTrackOnceConsented(
    "discover_session__started",
    () => {
      const embeddedInApp = Cookies.get(EMBEDDED_IN_APP_COOKIE) === "true";
      const activities = activity
        ? [activity]
        : parseSelection(searchParams ?? {}).activities;

      return {
        ...getDiscoverSessionProps(searchParams, embeddedInApp),
        area_id:
          location && mapAreaIds.includes(location as MapAreaId)
            ? location
            : null,
        preselected_activities: activities.map(slugify),
      };
    },
    { oncePerTab: true },
  );

  return null;
}
